import React, { useState } from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import {
  trackVideoPlayEvent,
  trackVideoMilestoneEvent,
} from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/video';
import { VideoPlayer } from '@cotyorg/ccx-organism-video';
import IconButton from '@cotyorg/ccx-molecules/IconButton';

const Tip = ({ index, image, description }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="tips__tip">
      <div className="tips__image__wrapper">
        <button
          className="tips__image"
          type="button"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <img src={R.prop('url', image)} alt={R.prop('title', image)} />
        </button>
        {isOpen && (
          <div className="tips__video">
            <VideoPlayer
              videosStoreDataKey={`tipsAndTricksVideo${index}`}
              showControls={false}
              autoPlay
              title=""
              shouldUseDefaultTitle
              onProgress={({
                url,
                duration,
                progress,
                videoMilestone,
                title,
              }) =>
                trackVideoMilestoneEvent({
                  url,
                  duration,
                  progress,
                  videoMilestone,
                  title,
                })
              }
              onPlay={({ url, duration, progress, title }) =>
                trackVideoPlayEvent({
                  url,
                  duration,
                  progress,
                  title,
                })
              }
              config={{
                youtube: {
                  playerVars: {
                    controls: 1,
                  },
                  embedOptions: {
                    host: 'https://www.youtube-nocookie.com',
                  },
                },
                file: {
                  attributes: {
                    controls: true,
                  },
                },
              }}
            />
          </div>
        )}
      </div>
      <div className="tips__description">
        <span>{index + 1}</span>
        <p dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  );
};

Tip.propTypes = {
  image: PropTypes.objectOf(PropTypes.object),
  index: PropTypes.number,
  description: PropTypes.string,
};

export default Tip;
